import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  quizzes: {},
};

export const quizSlice = createSlice({
  initialState,
  name: "quiz",
  reducers: {
    setQuiz: (state, action) => {
      state.quizzes = action.payload;
    },
  },
});
export const { setQuiz } = quizSlice.actions;

export default quizSlice;
